import Joi from 'joi';

const DynamicDataType = Joi.string().allow('');

export default DynamicDataType;
